export default "__VITE_ASSET__BMDn_ZGL__"